<template>
	<div class="login1">
		<img src="@/image/back-0.jpg" class="back-img-login" alt="" />
		<div class="logo_box">
			<img src="@/assets/imgs/logo.png" alt="" @click="jumpChange" />
		</div>

		<div class="login_box">
			<div class="top">
				<img src="../image/logoxiao.png" alt="" @click="jumpChange" />
			</div>
			<div class="mid">
				<div class="top">
					<div @click="loginType1(1)" :class="['left', loginType == 1 ? 'nav_active' : '']">
						OA账号登录
						<div v-if="loginType == 1" class="xian"></div>
					</div>
					<div @click="loginType1(0)" :class="['right', loginType == 0 ? 'nav_active' : '']">
						账号登录
						<div v-if="loginType == 0" class="xian"></div>
					</div>
				</div>
				<div class="bottom">
					<div class="item">
						<input
							v-if="loginType == 0"
							v-model="admin.account"
							type="text"
							:placeholder="mobileVerifCodeOpen ? mobileAccount[1] : mobileAccount[0]"
							maxlength="25"
						/>
						<input
							v-if="loginType == 1 && !mobileVerifCodeOpen"
							v-model="admin.phone"
							type="text"
							placeholder="请输入OA账号"
							maxlength="25"
						/>
						<input
							v-if="loginType == 1 && mobileVerifCodeOpen"
							v-model="admin.account"
							type="text"
							placeholder="请输入手机号码"
							maxlength="25"
						/>
					</div>
					<div class="item" v-if="loginType == 0 && mobileVerifCodeOpen">
						<input type="text" placeholder="请输入验证码" v-model="mobileCode" />
						<div
							style="
								font-size: 12px;
								font-weight: 400;
								color: #e60000;
								line-height: 28px;
								width: 75px;
							"
						>
							<span @click="getPost" v-show="timer == null">获取验证码</span>
							<span v-show="timer != null">({{ count }})</span>
						</div>
					</div>
					<div class="item" v-if="loginType == 1 && mobileVerifCodeOpen">
						<input type="text" placeholder="请输入验证码" v-model="mobileCode" />
						<div
							style="
								font-size: 12px;
								font-weight: 400;
								color: #e60000;
								line-height: 28px;
								width: 75px;
							"
						>
							<span @click="getPost" v-show="timer == null">获取验证码</span>
							<span v-show="timer != null">({{ count }})</span>
						</div>
					</div>
					<div class="item" v-if="!mobileVerifCodeOpen">
						<input
							v-if="loginType == 0"
							:type="showType ? 'password' : 'text'"
							v-model="admin.password"
							placeholder="请输入密码"
							maxlength="20"
							name=""
							id=""
						/>
						<input
							v-else
							:type="showType ? 'password' : 'text'"
							v-model="admin.post"
							placeholder="请输入OA账号密码"
							maxlength="20"
							name=""
							id=""
						/>
						<div class="yincang-eyes">
							<img
								@click="showType1"
								v-if="showType"
								style="width: 12px; height: 12px"
								src="../image/yincang.png"
								alt=""
							/>
							<img
								@click="showType1"
								v-else
								style="width: 12px; height: 12px"
								src="../image/xianshi.png"
								alt=""
							/>
						</div>
						<!-- <div
              style="
                font-size: 12px;

                font-weight: 400;
                color: #e60000;
                line-height: 28px;
                width: 75px;
              "
              v-else
            >
              <span @click="getPost" v-show="timer == null">获取验证码</span
              ><span v-show="timer != null">({{ count }})</span>
            </div> -->
					</div>
					<div class="item1" v-if="mobileVerifCodeOpen">
						<div></div>
						<div class="account-login-text" @click="onBindPhoneLogin(false)">
							{{ mobileLogin_Text[loginType] }}
						</div>
					</div>
					<div class="item1">
						<div class="left" style="position: relative" v-if="!mobileVerifCodeOpen">
							<el-checkbox style="margin-right: 5px" v-model="checked" @change="checkboxChange"
								><span style="margin-left: -5px">下次自动登录</span></el-checkbox
							>
							<div class="red-text" @click="onBindPhoneLogin(true)" v-if="!mobileVerifCodeOpen">
								手机快捷登录
							</div>
						</div>
						<div
							@click="Forgot_password"
							v-if="loginType == 0 && !mobileVerifCodeOpen"
							class="right"
						>
							<span style="cursor: pointer; color: #e60000">忘记密码？</span>
						</div>
					</div>
				</div>
			</div>
			<div class="bottom">
				<div class="top" @click="phoneLogin" v-if="mobileVerifCodeOpen"> 登录 </div>
				<div @click="login" class="top" v-else>登录</div>
				<div class="bottom">
					<el-checkbox style="margin-right: 5px" v-model="checkeds"
						><span style="margin-left: -5px">我已阅读并同意</span></el-checkbox
					>
					<span @click="agreement(1)" style="color: #46ace7; cursor: pointer">《用户协议》</span
					>和<span @click="agreement(2)" style="color: #46ace7; cursor: pointer">《隐私政策》</span>
				</div>
				<div class="bottom-explain" v-if="loginType == 0">
					经销商如无设计岛账号，请联系客服：<span>0752-5333672</span>
				</div>
			</div>
		</div>

		<el-dialog :title="agreeCont.name" :visible.sync="centerDialogVisible" width="30%" center>
			<span class="dialog_content" v-html="agreeCont.content"></span>
			<span slot="footer" class="dialog-footer">
				<el-button
					@click="
						centerDialogVisible = false;
						checkeds = false;
					"
					>取 消</el-button
				>
				<el-button
					type="primary"
					@click="
						centerDialogVisible = false;
						checkeds = true;
					"
					>确 定</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import { $login, $send_code, $mobilelogin, $agreement } from '../api/index';
	import { baseURL } from '@/api/request';
	export default {
		data() {
			return {
				mobileLogin_Text: ['账号密码登录', 'OA账号密码登录'],
				mobileAccount: ['请输入手机号码', '请输入手机号码'],
				////手机号码登录
				mobileVerifCodeOpen: false,
				mobileCode: '',
				////////
				centerDialogVisible: false,
				checked: false, //true 为自动登录
				checkeds: true,
				loginType: 1,
				admin: {
					account: '',
					password: '',
					post: '',
					phone: '',
				},

				showType: 1,

				count: 60,
				timer: null,
				agreeCont: {},
			};
		},
		mounted() {
			// this.admin.account = this.$store.state.userAccount || "";

			// tabs索引 0=设计岛,1=OA  <==>  登录type 1=设计岛,2=OA
			this.loginType = this.$store.state.saveUserOA == 2 ? 1 : 0;
			if (this.loginType) {
				// 1 OA
				this.admin.phone = this.$store.state.userAccount || '';
			} else {
				// 0 设计岛
				this.admin.account = this.$store.state.userAccount || '';
			}
		},
		methods: {
			//用户协议和隐私政策接口
			agreement(type) {
				$agreement({ type }).then((res) => {
					this.agreeCont = res.data;
					this.centerDialogVisible = true;
				});
			},
			// 获取验证码
			getPost() {
				let that = this;
				const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				let phone = this.admin.account;
				if (phone == '' || phone.length <= 10 || !reg.test(phone)) {
					this.$message.error('手机号格式错误！');
					return;
				}
				let nowTime = new Date().getTime();
				let lastTime = localStorage.getItem('code_time');
				if (lastTime && nowTime - lastTime < 60000) {
					this.count = parseInt((nowTime - lastTime) / 1000);
					this.$message.error(`${this.count}秒，请勿重复操作`);
					clearInterval(this.timer);
					this.timer = setInterval(() => {
						if (this.count > 0) {
							this.count--;
						} else {
							clearInterval(this.timer);
							this.timer = null;
							this.count = 60;
						}
					}, 1000);
					return;
				}

				let data = {
					mobile: this.admin.account,
					event: 'register',
				};
				$send_code(data)
					.then((response) => {
						localStorage.setItem('code_time', nowTime);
						this.$message.success({
							message: `验证码已发送至手机${response.data.mobile}，请注意查收！`,
							showClose: true,
						});
						// this.$alert(
						//   `验证码已发送至手机${response.data.mobile}，请注意查收！`,
						//   "提示",
						//   {
						//     confirmButtonText: "确定",
						//     callback: () => {},
						//   }
						// );

						that.timer = setInterval(() => {
							if (this.count > 0) {
								that.count--;
							} else {
								clearInterval(that.timer);
								that.timer = null;
								that.count = 60;
							}
						}, 1000);
					})
					.catch(() => {
						that.count = 10;
						that.timer = setInterval(() => {
							if (this.count > 0) {
								that.count--;
							} else {
								clearInterval(that.timer);
								that.timer = null;
								that.count = 10;
							}
						}, 1000);
					});
			},
			showType1() {
				this.showType = !this.showType;
			},
			login() {
				if (this.checkeds == false) {
					this.$message.error('请先阅读条款同意后，再进行登录');
					return;
				}
				if (this.loginType == 0) {
					this.adminLogin(1);
				} else {
					this.adminLogin(2);
				}
			},
			adminLogin(type) {
				let that = this;
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
				});

				let { account, password, post, phone } = this.$data.admin;
				let data = {
					type,
					// account: this.admin.account,
					// password: this.admin.password,
				};

				// admin: {
				//   account: "",
				//   password: "",
				//   post: "",
				//   phone: "",
				// },
				switch (type) {
					case 1:
						data.account = account;
						data.password = password;
						break;
					case 2:
						data.account = phone;
						data.password = post;
						break;
				}

				if (data.account == '') {
					this.$message.error({
						message: '账号不能为空，请填写账号',
						showClose: true,
					});
					loading.close();
					return;
				} else if (data.password == '') {
					this.$message.error({
						message: '密码不能为空，请填写密码',
						showClose: true,
					});
					loading.close();
					return;
				} else {
					$login(data)
						.then((response) => {
							loading.close();

							this.$message({
								showClose: true,
								message: '登录成功',
								type: 'success',
							});
							//自动登录存cooking 否则存session
							let token = response.data.userinfo.token;
							that.$store.commit('SetChecked', this.checked);
							that.$store.commit('SetUserInfo', response.data.userinfo);
							this.$store.commit('saveUser', data.account);
							this.$store.commit('saveUserOA', type); // 登录type 1=设计岛,2=OA
							if (this.checked) {
								// that.$store.commit("SetUserInfo", response.data.userinfo);
								sessionStorage.removeItem('cdntoken');
							} else {
								sessionStorage.setItem('cdntoken', token); //把data对应的值保存到sessionStorage
							}

							//首选判断当前的浏览器是不是微信浏览器
							let isWechat = isWeiXin();
							if (isWechat) {
								let urlParmas = `${document.location.protocol}//${document.domain}${
									document.location.port ? ':' + document.location.port : ''
								}`;
								let urlEncode = encodeURI(urlParmas);
								window.location.href = `${baseURL}/wechat_login?token=${response.data.userinfo.token}&url=${urlEncode}`;
							} else {
								//表明非微信浏览器环境下(可以引导使用扫码登录等)
								this.$router.push('/');
							}
						})
						.catch((res) => {
							loading.close();
							console.log(res);
						});
				}
			},
			phoneLogin() {
				let that = this;
				if (this.checkeds == false) {
					this.$message.error('请先阅读条款同意后，再进行登录');
					return;
				}

				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
				});
				let data = {
					mobile: this.admin.account,
					captcha: this.mobileCode,
					type: this.loginType == 0 ? 1 : 2,
				};
				const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				if (data.mobile == '' || data.mobile.length <= 10 || !reg.test(data.mobile)) {
					this.$message.error({
						message: '请检查手机号码，再试一次',
						showClose: true,
					});
					loading.close();
					return;
				} else if (data.captcha == '') {
					this.$message.error({
						message: '验证码不能为空，请填写验证码',
						showClose: true,
					});
					loading.close();
					return;
				} else {
					$mobilelogin(data)
						.then((response) => {
							loading.close();

							this.$message({
								showClose: true,
								message: '登录成功',
								type: 'success',
							});
							// that.$store.commit("SetUserInfo", response.data.userinfo);

							//自动登录存cooking 否则存session
							let token = response.data.userinfo.token;
							// that.$store.commit("SetChecked", this.checked);
							that.$store.commit('SetUserInfo', response.data.userinfo);
							this.$store.commit('saveUser', data.account);
							if (this.checked) {
								// that.$store.commit("SetUserInfo", response.data.userinfo);
								sessionStorage.removeItem('cdntoken');
							} else {
								sessionStorage.setItem('cdntoken', token); //把data对应的值保存到sessionStorage
							}

							//首选判断当前的浏览器是不是微信浏览器
							let isWechat = isWeiXin();
							if (isWechat) {
								let urlParmas = `${document.location.protocol}//${document.domain}${
									document.location.port ? ':' + document.location.port : ''
								}`;
								let urlEncode = encodeURI(urlParmas);
								window.location.href = `${baseURL}/wechat_login?token=${response.data.userinfo.token}&url=${urlEncode}`;
							} else {
								//表明非微信浏览器环境下(可以引导使用扫码登录等)
								this.$router.push('/');
							}

							// let token = response.data.userinfo.token;

							// that.$store.commit("SetChecked", this.checked);
							// that.$store.commit("SetUserInfo", response.data.userinfo);
							// if (this.checked) {
							//   // that.$store.commit("SetUserInfo", response.data.userinfo);
							//   sessionStorage.removeItem("cdntoken");
							// } else {
							//   sessionStorage.setItem("cdntoken", token); //把data对应的值保存到sessionStorage
							// }
						})
						.catch((res) => {
							loading.close();
							console.log(res);
						});
				}
			},
			loginType1(e) {
				this.loginType = e;
				// if (this.loginType == 1) {
				//   this.mobileVerifCodeOpen = false;
				//   this.mobileCode = "";
				// }
				this.mobileCode = '';
				this.admin = {
					account: '',
					password: '',
					post: '',
					phone: '',
				};
			},
			Forgot_password() {
				this.$router.push('/Forgot_password');
			},
			//微信H5网页授权登录流程(公众号登录流程)
			async weixinOALoginFlow() {},

			// 下次自动点击
			checkboxChange() {
				// this.checked = true;
				// this.checkeds = this.checked;
			},

			// logo 跳转
			jumpChange() {
				this.$router.push('/');
			},
			// 点击 手机快捷登录
			onBindPhoneLogin(type) {
				this.mobileVerifCodeOpen = type;
				this.mobileCode = '';
				this.admin = {
					account: '',
					password: '',
					post: '',
					phone: '',
				};
			},
		},
	};
	function isWeiXin() {
		var ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger') {
			return true;
		} else {
			return false;
		}
	}
</script>
<style lang="scss" scoped>
	.login1 {
		position: relative;
		box-sizing: border-box;
		min-height: 900px;
		width: 100%;
		height: 100vh;
		overflow: hidden;
		// background-image: url("../image/back-0.jpg");
		// background-size: 100% 100%;
		// background-size: cover;
	}
	.back-img-login {
		position: relative;
		box-sizing: border-box;
		min-height: 900px;
		width: 1920px;
		object-fit: cover;
		filter: brightness(60%);
	}
	.logo_box {
		position: absolute;
		top: 39px;
		left: 240px;
		width: 160px;
		// height: 56px;
		z-index: 10;
		img {
			cursor: pointer;
			display: block;
			width: 100%;
			// height: 100%;
		}
	}

	.login_box {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 220px;
		width: 530px;
		min-height: 625px;
		background: #282727;
		border-radius: 4px;
		padding: 65px 76px 0px;
		padding-bottom: 24px;
		opacity: 0.86;
		z-index: 10;
		.top {
			img {
				cursor: pointer;
				width: 160px;
				margin-bottom: 60px;
			}
		}
		.mid {
			margin-bottom: calc(var(--proportion) * 85px);

			.top {
				margin-bottom: 40px;
				display: flex;
				font-size: 18px;

				color: #ffffff70;
				.left {
					cursor: pointer;

					margin-right: 32px;
					.xian {
						width: 24px;
						height: 4px;
						background: #ffffff;
						opacity: 0.85;
						margin-top: 8px;
					}
				}
				.right {
					cursor: pointer;
					.xian {
						width: 24px;
						height: 4px;
						background: #ffffff;
						opacity: 0.85;
						margin-top: 8px;
					}
				}

				.nav_active {
					// font-size: 20px;
					color: #ffffff;
					opacity: 0.85;
				}
			}
			.bottom {
				.item {
					position: relative;
					display: flex;
					align-items: center;
					border-bottom: 1px solid #585858;
					height: 45px;
					margin-bottom: 20px;
					input {
						color: #ffffff;
						font-weight: 400;
						font-size: 16px;

						width: 100%;
						background-color: #282727;
						height: 100%;
						padding: 0 10px;
					}
					.yincang-eyes {
						position: absolute;
						top: 0px;
						right: 0px;
						width: 12px;
						height: 100%;
					}
				}
				.item1 {
					display: flex;
					font-size: 14px;
					justify-content: space-between;
					font-weight: 400;
					color: rgba(255, 255, 255, 0.6);
				}
			}
		}

		.account-login-text {
			font-size: 14px;
			font-weight: 400;
			color: #e60000;
		}
		.bottom {
			cursor: pointer;
			text-align: center;
			.top {
				width: 100%;
				height: 48px;
				background: #e60000;
				// margin-top: 65px;
				font-size: 18px;

				// font-weight: bold;
				color: #ffffff;
				text-align: center;
				line-height: 48px;
			}
			.bottom {
				font-size: 14px;
				margin-top: 20px;
				color: #999999;
			}
		}
	}
	.dialog_content {
		overflow-y: scroll;
	}

	.el-checkbox {
		color: #fff;
	}
	::v-deep.el-checkbox__input.is-checked .el-checkbox__inner::after {
		content: '';
		border: 1px solid #ffc342;
		border-left: 0;
		border-top: 0;
	}
	::v-deep.el-checkbox__input.is-checked + .el-checkbox__label {
		color: #ffc342;
		margin-top: 1px;
	}
	::v-deep .el-checkbox__inner {
		background: transparent;
		border-radius: 50%;
	}
	::v-deep.el-checkbox__input.is-focus .el-checkbox__inner,
	.el-checkbox__inner:hover {
		border-color: #fff;
	}
	::v-deep.el-checkbox__input.is-checked .el-checkbox__inner {
		background: transparent;
		border-color: #ffc342;
	}
	::v-deep .el-checkbox__inner:hover {
		border-color: #fff;
	}

	::v-deep .el-dialog__body {
		overflow-y: scroll;
		height: 483px;
	}
	::v-deep {
		.el-checkbox__label {
			color: #999999;
		}
		.el-checkbox__input.is-checked + .el-checkbox__label {
			color: #999999;
		}
	}
	.bottom-explain {
		margin-top: 40px;
		font-size: 14px;
		font-weight: 400;
		color: #999999;

		span {
			color: #e60000;
		}
	}
	.red-text {
		position: absolute;
		top: 0px;
		right: -110px;
		width: 100px;
		font-size: 14px;
		font-weight: 400;
		color: #e60000;
	}
</style>
